import { render, staticRenderFns } from "./activity.vue?vue&type=template&id=008328c2&scoped=true&"
import script from "./activity.vue?vue&type=script&lang=js&"
export * from "./activity.vue?vue&type=script&lang=js&"
import style0 from "./activity.vue?vue&type=style&index=0&id=008328c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008328c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('008328c2')) {
      api.createRecord('008328c2', component.options)
    } else {
      api.reload('008328c2', component.options)
    }
    module.hot.accept("./activity.vue?vue&type=template&id=008328c2&scoped=true&", function () {
      api.rerender('008328c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/event/components/activity.vue"
export default component.exports